(function(){
  'use strict';
  function money(cents,currency){try{var whole=cents%100===0;return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD',minimumFractionDigits:whole?0:2,maximumFractionDigits:2}).format(cents/100);}catch(e){return '$'+(cents/100).toFixed(2);}}
  function setCartCount(n){document.querySelectorAll('[data-ergo-cart-count]').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n);});}

  var ErgoQty=function(){return Reflect.construct(HTMLElement,[],ErgoQty);};
  ErgoQty.prototype=Object.create(HTMLElement.prototype);
  ErgoQty.prototype.connectedCallback=function(){
    var input=this.querySelector('input');
    this.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        var d=b.dataset.dir==='up'?1:-1;
        input.value=Math.max(parseInt(input.min||'1',10),(parseInt(input.value,10)||1)+d);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  };
  customElements.define('ergo-qty',ErgoQty);

  var ErgoGallery=function(){return Reflect.construct(HTMLElement,[],ErgoGallery);};
  ErgoGallery.prototype=Object.create(HTMLElement.prototype);
  ErgoGallery.prototype.connectedCallback=function(){
    var main=this.querySelector('[data-ergo-main] img');
    var self=this;
    this.querySelectorAll('[data-ergo-thumb]').forEach(function(t){
      t.addEventListener('click',function(e){
        e.preventDefault();
        if(main&&t.dataset.full){main.src=t.dataset.full;main.removeAttribute('srcset');}
        self.querySelectorAll('[data-ergo-thumb]').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
  };
  customElements.define('ergo-gallery',ErgoGallery);

  var ErgoProductForm=function(){return Reflect.construct(HTMLElement,[],ErgoProductForm);};
  ErgoProductForm.prototype=Object.create(HTMLElement.prototype);
  ErgoProductForm.prototype.connectedCallback=function(){
    var self=this;
    this.form=this.querySelector('form');
    if(!this.form)return;
    var vjson=this.querySelector('[data-ergo-variants]');
    this.variants=vjson?JSON.parse(vjson.textContent):[];
    this.currency=this.dataset.currency||'USD';
    this.idInput=this.form.querySelector('input[name="id"]');
    this.priceEl=this.querySelector('[data-ergo-price]');
    this.compareEl=this.querySelector('[data-ergo-compare]');
    this.button=this.form.querySelector('[data-ergo-atc]');
    this.buttonText=this.form.querySelector('[data-ergo-atc-text]');
    this.spinner=this.form.querySelector('[data-ergo-spinner]');
    this.errorEl=this.querySelector('[data-ergo-error]');
    this.addedEl=this.querySelector('[data-ergo-added]');
    this.querySelectorAll('input[data-ergo-option]').forEach(function(i){
      i.addEventListener('change',function(){self.onOptionChange();});
    });
    this.form.addEventListener('submit',function(e){self.onSubmit(e);});
  };
  ErgoProductForm.prototype.selectedOptions=function(){
    var opts=[];
    this.querySelectorAll('[data-ergo-option-group]').forEach(function(g){
      var c=g.querySelector('input:checked');
      opts.push(c?c.value:null);
    });
    return opts;
  };
  ErgoProductForm.prototype.onOptionChange=function(){
    var opts=this.selectedOptions();
    var v=this.variants.find(function(x){
      return x.options.every(function(o,i){return o===opts[i];});
    });
    this.setVariant(v);
  };
  ErgoProductForm.prototype.setVariant=function(v){
    if(this.errorEl)this.errorEl.hidden=true;
    if(!v){
      if(this.button)this.button.disabled=true;
      if(this.buttonText)this.buttonText.textContent=this.dataset.unavailableText||'Unavailable';
      return;
    }
    if(this.idInput)this.idInput.value=v.id;
    if(this.priceEl)this.priceEl.textContent=money(v.price,this.currency);
    if(this.compareEl){
      if(v.compare_at_price&&v.compare_at_price>v.price){
        this.compareEl.textContent=money(v.compare_at_price,this.currency);
        this.compareEl.hidden=false;
      }else{this.compareEl.hidden=true;}
    }
    if(this.button)this.button.disabled=!v.available;
    if(this.buttonText)this.buttonText.textContent=v.available?(this.dataset.addText||'Add to cart'):(this.dataset.soldOutText||'Sold out');
    try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}catch(e){}
  };
  ErgoProductForm.prototype.showError=function(msg){
    if(!this.errorEl)return;
    this.errorEl.textContent=msg;
    this.errorEl.hidden=false;
  };
  ErgoProductForm.prototype.onSubmit=function(e){
    e.preventDefault();
    var self=this;
    if(this.button&&this.button.disabled)return;
    if(this.errorEl)this.errorEl.hidden=true;
    if(this.button)this.button.setAttribute('aria-busy','true');
    if(this.spinner)this.spinner.hidden=false;
    var fd=new FormData(this.form);fd.append('sections','cart-drawer,cart-icon-bubble');fd.append('sections_url',window.location.pathname);
    fetch((this.dataset.addUrl||'/cart/add')+'.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok){self.showError(res.j.description||res.j.message||'Could not add to cart.');return;}
        var drawer=document.querySelector('cart-drawer');
        if(drawer&&res.j.sections){try{drawer.renderContents(res.j);drawer.classList.remove('is-empty');}catch(err){}}
        return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){setCartCount(c.item_count);});
      })
      .catch(function(){self.showError('Network error. Please try again.');})
      .finally(function(){
        if(self.button)self.button.removeAttribute('aria-busy');
        if(self.spinner)self.spinner.hidden=true;
      });
  };
  customElements.define('ergo-product-form',ErgoProductForm);

  var ErgoCart=function(){return Reflect.construct(HTMLElement,[],ErgoCart);};
  ErgoCart.prototype=Object.create(HTMLElement.prototype);
  ErgoCart.prototype.connectedCallback=function(){
    var self=this;
    this.addEventListener('click',function(e){
      var btn=e.target.closest('[data-ergo-line-qty]');
      var rm=e.target.closest('[data-ergo-line-remove]');
      if(btn){
        e.preventDefault();
        var line=btn.dataset.line;
        var input=self.querySelector('[data-ergo-line-input="'+line+'"]');
        var q=(parseInt(input&&input.value,10)||1)+(btn.dataset.dir==='up'?1:-1);
        self.change(line,Math.max(0,q));
      }
      if(rm){e.preventDefault();self.change(rm.dataset.line,0);}
    });
  };
  ErgoCart.prototype.change=function(line,qty){
    var self=this;
    this.classList.add('is-loading');
    fetch((this.dataset.changeUrl||'/cart/change')+'.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:parseInt(line,10),quantity:qty,sections:this.dataset.sectionId})
    })
      .then(function(r){return r.json();})
      .then(function(c){
        if(typeof c.item_count!=='undefined')setCartCount(c.item_count);
        var html=c.sections&&c.sections[self.dataset.sectionId];
        if(html){
          var d=document.createElement('div');
          d.innerHTML=html;
          var fresh=d.querySelector('ergo-cart');
          if(fresh)self.innerHTML=fresh.innerHTML;
        }
      })
      .finally(function(){self.classList.remove('is-loading');});
  };
  customElements.define('ergo-cart',ErgoCart);

  /* Header cart icon opens the cart drawer instead of loading /cart.
     Dawn binds this to #cart-icon-bubble, but that same id is the node Dawn
     overwrites on every cart update - giving it to the custom ErgoVia icon would
     replace the icon markup - so bind our own class explicitly instead.
     The anchor keeps its href, so a modified click, a missing drawer, or JS
     failing all still reach the cart page. The control is never dead. */
  function ergoCartDrawer(){
    var d=document.querySelector('cart-drawer');
    return d&&typeof d.open==='function'?d:null;
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest?e.target.closest('.ergo-cart-btn'):null;
    if(!btn||e.defaultPrevented)return;
    /* let cmd/ctrl/shift/middle clicks open the cart page as the user expects */
    if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var drawer=ergoCartDrawer();
    if(!drawer)return;
    e.preventDefault();
    drawer.open(btn);
  });
  /* only advertise it as a dialog trigger once the drawer really exists */
  function ergoMarkCartTriggers(){
    if(!ergoCartDrawer())return;
    document.querySelectorAll('.ergo-cart-btn').forEach(function(btn){
      btn.setAttribute('role','button');
      btn.setAttribute('aria-haspopup','dialog');
    });
  }
  if(window.customElements&&customElements.whenDefined){
    customElements.whenDefined('cart-drawer').then(ergoMarkCartTriggers).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded',ergoMarkCartTriggers);

  document.addEventListener('change',function(e){
    if(e.target.matches('[data-ergo-filter-input]')){
      var f=document.getElementById('ErgoFiltersForm');
      if(f)f.submit();
    }
  });
})();
